import { CHAT_ROOM_ALL, type ChatMessage, type ChatTarget } from "@xop/dashboard-shared";

/**
 * react-query keys for chat — shared by the page hooks AND the realtime
 * provider, which pushes live messages into these same caches so an open
 * thread / the sidebar badge update without a refetch.
 */
export const chatKeys = {
  overview: ["chat", "overview"] as const,
  conversation: (conversationKey: string) => ["chat", "conversation", conversationKey] as const,
};

/** URL path segment for a target: "all" (the room) or the user id (a DM). */
export function targetSegment(target: ChatTarget): string {
  return target.kind === "room" ? target.room : String(target.user_id);
}

/**
 * The conversation key for a message FROM the given viewer's perspective —
 * mirrors the server's read-cursor key (`"room:all"` / `"dm:<otherUserId>"`).
 * For a DM the "other" party is the sender when I received it, or the
 * recipient when it's the echo of my own send.
 */
export function messageConversationKey(message: ChatMessage, selfId: number): string {
  if (message.scope === "room") return `room:${message.room ?? CHAT_ROOM_ALL}`;
  const other = message.sender_id === selfId ? message.recipient_id : message.sender_id;
  return `dm:${other ?? 0}`;
}
